export enum Channel {
  'airbnb' = 'airbnb',
  'booking_com' = 'booking_com',
  furnishedfinder = 'furnishedfinder',
  'golightly' = 'golightly',
  'google' = 'google',
  'homads' = 'homads',
  'homeaway' = 'homeaway',
  'hometogo' = 'hometogo',
  'hvmi' = 'hvmi',
  'orbirental' = 'orbirental',
  'tripadvisor' = 'tripadvisor',
  'vacaymyway' = 'vacaymyway',
}

export interface ChannelSettings {
  enumId: Channel;
  externalLink?: string;
  isActive: boolean;
  name: string;
}

export type ChannelSettingsResponseTO = ChannelSettings[];

export interface ChannelSettingsUpdatePayload {
  channelName: string;
  link: string;
  propertyUid: string;
  successCallback?: Function;
}

export enum VrboCancellationPolicy {
  CUSTOM = 'CUSTOM',
  FIRM = 'FIRM',
  MODERATE = 'MODERATE',
  NO_REFUND = 'NO_REFUND',
  RELAXED = 'RELAXED',
  STRICT = 'STRICT',
}

export enum VrboPromotionPlan {
  MOBILE = 'MOBILE',
  MEMBER_BLUE = 'MEMBER_BLUE',
  MEMBER_SILVER = 'MEMBER_SILVER',
  MEMBER_GOLD = 'MEMBER_GOLD',
  NEW_LISTING_DISCOUNT = 'NEW_LISTING_DISCOUNT',
}
